export default __webpack_public_path__ + "static/media/lock.d6f3fcda.svg";